import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type ConsumptionExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly food?: string;
  readonly foodName?: string;
  readonly drugstore?: string;
  readonly drugstoreName?: string;
  readonly telecommunication?: string;
  readonly telecommunicationName?: string;
  readonly cigarettes?: string;
  readonly cigarettesName?: string;
  readonly vehicle?: string;
  readonly vehicleName?: string;
  readonly children?: string;
  readonly childrenName?: string;
  readonly gifts?: string;
  readonly giftsName?: string;
  readonly customItems?: { name?: string; value?: string }[];
};

export const getConsumptionExpenseFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<ConsumptionExpenseFormType> = (t) => {
  const customItemSchema = object({
    name: string().required(t(Resources.Validation.Required)),
    value: string()
      .required(t(Resources.Validation.Required))
      .greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 })),
  });

  return object({
    detailed: boolean().optional(),
    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),
    food: string().optional(),
    foodName: string().optional(),
    drugstore: string().optional(),
    drugstoreName: string().optional(),
    telecommunication: string().optional(),
    telecommunicationName: string().optional(),
    cigarettes: string().optional(),
    cigarettesName: string().optional(),
    vehicle: string().optional(),
    vehicleName: string().optional(),
    children: string().optional(),
    childrenName: string().optional(),
    gifts: string().optional(),
    giftsName: string().optional(),
    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : schema.optional().nullable();
    }),
  }).defined();
};
